import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import '@mui/material/styles';


import {ToastContainer} from "react-toastify";
import {Provider} from "react-redux";
import store from "./utils/store";
import i18n from "./i18n";

// document.documentElement.setAttribute('data-bs-theme', 'dark');

/** RTL-aware toasts: the app is Hebrew (RTL) by default, so the container must
 *  mirror. This lives OUTSIDE the App tree, where useTranslation's re-render
 *  binding doesn't fire — so subscribe to the i18n singleton's languageChanged
 *  event directly (App/RequireAuth switch the language after login). */
const DirectionalToastContainer: React.FC = () => {
    const [dir, setDir] = React.useState(i18n.dir());
    React.useEffect(() => {
        const onLanguageChanged = () => setDir(i18n.dir());
        i18n.on('languageChanged', onLanguageChanged);
        // App switches the language in ITS mount effect, which runs before this
        // one (sibling order) — re-read here so that early switch isn't missed.
        onLanguageChanged();
        return () => i18n.off('languageChanged', onLanguageChanged);
    }, []);
    return <ToastContainer position='bottom-left' rtl={dir === 'rtl'}/>;
};

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    // <React.StrictMode>
    <>
        <Provider store={store}>
            <App/>
        </Provider>
        <DirectionalToastContainer/>
    </>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
